import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Sectors from "@/components/Sectors";
import Stats from "@/components/Stats";
import Loans from "@/components/Loans";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

const SiteContent = () => (
  <div className="grain relative min-h-screen bg-white text-navy-900">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Sectors />
      <Stats />
      <Loans />
      <Team />
      <Contact />
    </main>
    <Footer />
    <ChatWidget />
  </div>
);

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <SiteContent />
    </LanguageProvider>
  );
}
